import React from 'react';
import './About.css';
import teamImage from '../assets/images/team.jpg';

function About() {
    return (
        <div className="about">
            <h1>About Us</h1>
            <img src={teamImage} alt="Our Team" />
            <p>
                We are a passionate team of web developers committed to building high-quality websites.
            </p>
            <p>
                Our mission: To deliver tailor-made web solutions that drive business growth and enhance online presence.
            </p>
            <a href="/contact" className="cta-btn">Get In Touch</a>
        </div>
    );
}

export default About;
